import { useState } from "react";
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
import { UtilsHelper } from "utils/helpers";

export function useReportWidgetAdditionalData<T>() {
  const [additionalData, setAdditionalData] = useState<T | undefined>(undefined);

  const parseAdditionalChartData = (dataStr?: string): T | undefined => {
    if (UtilsHelper.isEmpty(dataStr)) {
      return undefined;
    }
    try {
      const data = JSON.parse(dataStr!) as T;
      return data;
    } catch (error) {
      console.error(error);
      return undefined;
    }
  };

  const onChartSuccessHandler = (data?: WintSuperkollAPIModel.ReportWidget) => {
    const parsed = parseAdditionalChartData(data?.additionalDataJson);
    if (parsed) {
      setAdditionalData(parsed);
    }
  };

  return { additionalData, onChartSuccessHandler };
}


